import React from "react";
import { RichText } from "prismic-reactjs";
import { format } from "date-fns";
import { linkResolver } from "../prismic-configuration";

export default class PostItem extends React.Component {
  render() {
    const item = this.props.item;
    const fullWidthClass = item.data.main_image.url ? "col-9" : "col-12";

    return (
      <div className="row mb-4">
        {item.data.main_image.url ? (
          <div className="col-3">
            <a href={linkResolver(item)}>
              <img
                src={item.data.main_image.url}
                alt=""
                className="img-fluid"
              />
            </a>
          </div>
        ) : null}

        <div className={fullWidthClass}>
          <h5>
            <a className="text-blue" href={linkResolver(item)}>
              {item.data.title.length !== 0
                ? RichText.asText(item.data.title, linkResolver)
                : null}
            </a>
          </h5>
          <p className="publish-date text-sm">
            <i className="fas fa-calendar-alt" />{" "}
            {format(item.data.date, "DD MMMM YY")}
          </p>
          <p>
            {item.data.excerpt.length !== 0
              ? RichText.asText(item.data.excerpt, linkResolver)
              : null}
          </p>
          <div className="text-right">
            <a href={linkResolver(item)}>Read more</a>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PostItem.js